'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_AgentView$$anon$27() {
  this.axU = null;
  this.axV = false;
}
export { $c_Lpresto_AgentView$$anon$27 as $c_Lpresto_AgentView$$anon$27 };
$p = $c_Lpresto_AgentView$$anon$27.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_AgentView$$anon$27;
/** @constructor */
function $h_Lpresto_AgentView$$anon$27() {
}
export { $h_Lpresto_AgentView$$anon$27 as $h_Lpresto_AgentView$$anon$27 };
$h_Lpresto_AgentView$$anon$27.prototype = $p;
$p.P = (function() {
  if ((!this.axV)) {
    this.axU = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T3($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.axV = true;
  }
  return this.axU;
});
var $d_Lpresto_AgentView$$anon$27 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_AgentView$$anon$27, "presto.AgentView$$anon$27", ({
  DO: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_AgentView$$anon$27 as $d_Lpresto_AgentView$$anon$27 };
//# sourceMappingURL=presto.-Agent-View$$anon$27.js.map
